import { render } from "./IDateSwiperSkeleton.vue?vue&type=template&id=e99bddfa&scoped=true"
const script = {}

import "./IDateSwiperSkeleton.vue?vue&type=style&index=0&id=e99bddfa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99bddfa"]])

export default __exports__